import { ObserverConfig } from './interface';

export const OBSERVER_DEFAULT_CONFIG: ObserverConfig = {
  threshold: 0.9,
};
